import React, { useEffect } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import clsx from 'clsx'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { usePlan } from '../../../context/PlanContext'
import { toast } from 'react-toastify'
import { SAVE_PAYPAL_PAYMENT_CONFIG } from '../../../graphql/mutation'
import { GET_PAYPAL_PAYMENT_CONFIG } from '../../../graphql/query'
interface IProps {
  closePaypalModal: () => void
}
const PaypalModal: React.FC<IProps> = ({ closePaypalModal }) => {
  const { currentPlan } = usePlan()

  const { data: PaypalData, refetch } = useQuery(GET_PAYPAL_PAYMENT_CONFIG, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Configuration'
      }
    }
  })

  const [AddPaypalPaymentConfig] = useMutation(SAVE_PAYPAL_PAYMENT_CONFIG, {
    context: { headers: { 'access-control-allow-methods': 'Configuration' } }
  })

  const initialValues = {
    paypalClientId: PaypalData?.getPaypalPaymentConfig?.data?.clientId || '',
    paypalClientSecret: PaypalData?.getPaypalPaymentConfig?.data?.clientSecret || ''
  }
  console.log(PaypalData, 'PaypalData')

  const validationSchema = Yup.object({
    paypalClientId: Yup.string().required('Client id is required'),
    paypalClientSecret: Yup.string().required('Client secret id is required')
  })

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      AddPaypalPaymentConfig({
        variables: {
          input: {
            paypalClientId: values.paypalClientId,
            paypalClientSecret: values.paypalClientSecret,
            paypalMode: 'sandbox'
          }
        }
      })
        .then((res: any) => {
          closePaypalModal()
          if (
            res.data.AddPaypalPaymentConfig.status >= 200 &&
            res.data.AddPaypalPaymentConfig.status < 300
          ) {
            toast.success(res.data.AddPaypalPaymentConfig.message)
          } else {
            toast.error(res.data.AddPaypalPaymentConfig.message)
          }
          refetch()
        })
        .catch((err: any) => {
          closePaypalModal()
          toast.error('Sorry! Unexpected Error.')
          console.error(err)
        })
    }
  })
  return (
    <div className='collapse show'>
      <form className='form' onSubmit={formik.handleSubmit}>
        {formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )}

        <div className='d-flex justify-content-between align-items-center px-3 py-2'>
          <h2 className='mb-0'>Paypal Configuration</h2>
        </div>

        <div className='d-flex justify-content-between align-items-center px-3 py-2'>
          <p className='mb-0'>Please fill out all the required fields below.</p>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Client ID</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('paypalClientId')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.paypalClientId && formik.errors.paypalClientId
                })}
                placeholder='Client Id'
              />
              {formik.touched.paypalClientId && formik.errors.paypalClientId && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.paypalClientId)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Client Secret Id</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('paypalClientSecret')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid':
                    formik.touched.paypalClientSecret && formik.errors.paypalClientSecret
                })}
                placeholder='Client secret Id'
              />
              {formik.touched.paypalClientSecret && formik.errors.paypalClientSecret && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.paypalClientSecret)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='d-flex justify-content-end mt-4'>
            <button type='button' className='btn btn-secondary me-4' onClick={closePaypalModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-sm btn-primary' disabled={formik.isSubmitting}>
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default PaypalModal
